export default "__VITE_ASSET__797e436a__"